import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-collect",
  "use": "icon-collect-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-collect\"><defs><style>#icon-collect .a{fill:#c5aa7b;}</style></defs><g transform=\"translate(-41.333 -330.667)\"><g transform=\"translate(41.333 330.667)\"><path class=\"a\" d=\"M9.568.739a.5.5,0,0,1,.863,0L13.394,5.81a.5.5,0,0,0,.309.232l5.539,1.405a.5.5,0,0,1,.266.8l-3.72,4.59a.5.5,0,0,0-.11.352l.442,5.987a.5.5,0,0,1-.7.5L10.2,17.4a.5.5,0,0,0-.4,0L4.578,19.671a.5.5,0,0,1-.7-.5l.442-5.987a.5.5,0,0,0-.11-.352L.492,8.247a.5.5,0,0,1,.266-.8L6.3,6.042a.5.5,0,0,0,.309-.232Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/collect.svg
// module id = Tw70
// module chunks = 62